module.exports = __webpack_public_path__ + "img/oneIm.567fd8a1.png";